export default "__VITE_ASSET__CtOQN0y3__"